export default [
    {
        path: 'relatorio-permissao-papel',
        component: () => import(/* webpackChunkName: 'administracao-relatorio-permissao-papel' */ '@/views/administracao/relatorio-permissao-papel/Index'),
        redirect: 'relatorio-permissao-papel/index',
        children: [
            {
                name: 'administracao-relatorio-permissao-papel-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-relatorio-permissao-papel' */ '@/views/administracao/relatorio-permissao-papel/List'),
            },
        ]
    }
]